import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getFunctions } from "firebase/functions"
import { GoogleAuthProvider } from "firebase/auth"
import env from './env'

const firebaseConfig = {
  apiKey: env('FIREBASE_API_KEY'),
  authDomain: env('FIREBASE_AUTH_DOMAIN'),
  databaseURL: env('FIREBASE_DATABASE_URL'),
  projectId: env('FIREBASE_PROJECT_ID'),
  storageBucket: env('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('FIREBASE_APP_ID'),
}


const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const provider = new GoogleAuthProvider()
const functions = getFunctions(app)
functions.region = "asia-northeast1"

// AppCheck の初期化は reCAPTCHA v3 のサイトキー再設定が完了するまで一時的に無効化中。
// Firebase Console 側の Firestore enforcement も Monitoring（未適用）のため保護レベルは変わらない。
// 再有効化する際は initializeAppCheck と ReCaptchaV3Provider のインポート、
// FIREBASE_APPCHECK_DEBUG_TOKEN の dev フラグ設定、サイトキー読込ブロックを元に戻すこと。

export { app, auth, db, provider, functions }
